import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi";
import { useNotification } from "~hooks/useNotification";
import type { ImageResponse } from "~types/image";
import { ImageBaseTypes } from "~enums/imageBaseTypes";
import type { ImageTypes } from "~enums/imageTypes";

type UploadParameters = {
  baseType: ImageBaseTypes;
  baseId: string;
  imageType: ImageTypes;
  file: File;
};

const useUploadImage = () => {
  const { sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();

  return useMutation<ImageResponse, Error, UploadParameters>({
    mutationFn: ({ baseType, baseId, imageType, file }) => {
      // for organization images URL pattern is different
      const url =
        baseType === ImageBaseTypes.Organization
          ? `${sport}/o/${organizationId}/images/for/${baseType}/${imageType}`
          : `${sport}/o/${organizationId}/images/for/${baseType}/${baseId}/${imageType}`

      return request<ImageResponse>(url, { method: "POST", body: file, headers: { "Content-Type": file.type || "application/octet-stream" }})
    },
    onSuccess: (response: ImageResponse) => {
      if (response?.data?.[0]) {
        notification.success({
          message: formatMessage({ id: "image.upload.success" }),
          placement: "bottomRight",
        });
      }
    },
  });
};

export default useUploadImage;
